export default __webpack_public_path__ + "static/media/txt_h1.11f6fbb7.svg";